// extracted by mini-css-extract-plugin
export default {"gradientsGallery":"DuiHN9coTq","title":"fzbHbe7LyV","items":"enUvtRLAkX","item":"jR6FnSyPFG"};